import axios, { InternalAxiosRequestConfig } from 'axios'

import { getLineBearerToken } from 'utils/bearerToken'
import { reactAppNexusServer } from 'utils/config'

const nexusApi = axios.create({
  baseURL: reactAppNexusServer || undefined,
  timeout: 30000
})

nexusApi.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
  const token = getLineBearerToken()
  if (token) config.headers.Authorization = 'Bearer ' + token

  return config
}, error => Promise.reject(error))

export default nexusApi
